import React, { useState, useEffect } from 'react';
import '../styles/ImageCarousel.css';

const ImageCarousel = ({ images, alt, isHovered }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

    // Détection mobile/desktop
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Défilement automatique
  useEffect(() => {
    if (!images || images.length <= 1) return;

    // Sur desktop: défilement uniquement au survol
    if (!isMobile && !isHovered) return;

    // Sur mobile: défilement automatique pour toutes les cartes
    // Sur desktop: défilement au survol
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 2500);

    return () => clearInterval(interval);
  }, [images, isHovered, isMobile]);

  if (!images || images.length === 0) {
    return (
      <div className="carousel-container">
        <img 
          src="/img/defaultImgCar.webp"
          alt={alt}
          className="carousel-image"
        />
      </div>
    );
  }

  return (
    <div className="carousel-container">
      {/* Boutons de navigation - Desktop uniquement */}
      {images.length > 1 && !isMobile && (
        <>
          <button 
            className="carousel-nav prev" 
            onClick={prevImage}
            aria-label="Image précédente"
          >
            ‹
          </button>
          <button 
            className="carousel-nav next" 
            onClick={nextImage}
            aria-label="Image suivante"
          >
            ›
          </button>
        </>
      )}
      {images.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`${alt} - Image ${index + 1}`}
          className={`carousel-image ${index === currentIndex ? 'active' : ''}`}
          style={{
            opacity: index === currentIndex ? 1 : 0,
            transition: 'opacity 0.5s ease-in-out'
          }}
          onError={(e) => {
            e.target.src = '/img/defaultImgCar.webp';
          }}
        />
      ))}
      {/* Indicateurs - Desktop uniquement */}
      {images.length > 1 && !isMobile && (
        <div className="carousel-indicators">
          {images.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;
